@if (loadingService.isLoading() || force()) {
  <div class="fixed inset-0 z-[9999] bg-black/20 backdrop-blur-sm flex flex-col items-center justify-center animate-fadein">
    <div class="relative flex items-center justify-center w-40 h-40">

      <div class="absolute inset-0 rounded-full border-4 border-transparent border-t-[#00d2ff] border-r-[#3a7bd5] animate-spin-slow mix-blend-multiply opacity-80 shadow-[0_0_15px_rgba(0,210,255,0.4)]"></div>
      <div class="absolute inset-2 rounded-full border-4 border-transparent border-b-[#00d2ff] border-l-[#3a7bd5] animate-spin-reverse mix-blend-multiply opacity-60"></div>

      <div class="absolute inset-4 bg-gradient-to-tr  rounded-full animate-pulse-fast opacity-50 blur-sm"></div>

      <img src="/images/logos/logo-fraiche.webp" alt="Cargando..." class="w-[7rem] h-[7rem] object-contain z-10 animate-bounce-slow filter drop-shadow-md img-loading" onerror="this.src='/images/logos/ImgFCHV2qa.jpg'" />
    </div>

    @if (displayText()) {
      <div class="mt-5 animate-fadein" style="animation-delay: 0.2s; animation-fill-mode: both;">
        <div class="bg-gray-900/40 backdrop-blur-md px-4 py-1.5 rounded-full border border-white/10 shadow-lg flex flex-col items-center gap-1.5">
          <p class="text-white text-[10px] sm:text-xs font-bold tracking-widest capitalize text-center" style="text-shadow: 0 1px 2px rgba(0,0,0,0.9), 0 0 10px rgba(0, 210, 255, 0.5);">
            {{ displayText() }}
          </p>
          @if (loadingService.progress() !== null) {
            <div class="w-52 sm:w-64 h-2 bg-white/20 rounded-full overflow-hidden border border-white/10">
              <div
                class="h-full bg-gradient-to-r from-[#00d2ff] to-[#3a7bd5] transition-all duration-300 rounded-full shadow-[0_0_8px_rgba(0,210,255,0.7)]"
                [style.width.%]="loadingService.progress()">
              </div>
            </div>

            <span class="text-white/90 text-[10px] font-semibold">
              {{ loadingService.progress() }}%
            </span>
            @if (loadingService.seconds() !== null) {
              <span class="text-white/70 text-[10px] font-medium">
                Tiempo: {{ loadingService.seconds() }}s
              </span>
            }
          }
          <div class="flex justify-center gap-1.5 mb-0.5">
            <div class="w-1 h-1 rounded-full bg-[#00d2ff] animate-bounce" style="animation-delay: 0ms; box-shadow: 0 0 4px #00d2ff;"></div>
            <div class="w-1 h-1 rounded-full bg-[#3a7bd5] animate-bounce" style="animation-delay: 150ms; box-shadow: 0 0 4px #3a7bd5;"></div>
            <div class="w-1 h-1 rounded-full bg-white animate-bounce" style="animation-delay: 300ms; box-shadow: 0 0 4px white;"></div>
          </div>
        </div>
      </div>
    }
  </div>
}
